import { useState, useEffect } from "react";
import { Link } from "wouter";

const STORAGE_KEY = "parusa_cookies_accepted";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-cookie-banner="true"
      className="fixed bottom-0 left-0 right-0 z-[200] bg-card border-t border-primary/25 backdrop-blur-sm"
      style={{ animation: "slideUp 0.4s ease" }}
    >
      <style>{`@keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
      <div className="container mx-auto px-6 md:px-14 max-w-6xl py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-xs font-light text-muted-foreground leading-relaxed max-w-2xl">
          Мы используем cookies для улучшения работы сайта и аналитики.
          Продолжая использовать сайт, вы соглашаетесь с нашей{" "}
          <Link href="/privacy" className="text-primary hover:text-accent transition-colors underline underline-offset-2">
            политикой конфиденциальности
          </Link>
          .
        </p>
        <button
          onClick={accept}
          className="shrink-0 bg-primary text-primary-foreground px-8 py-2.5 text-[9px] tracking-[0.25em] uppercase hover:bg-primary/90 transition-colors"
        >
          Принять
        </button>
      </div>
    </div>
  );
}
